export default __webpack_public_path__ + "static/media/frozone_mobile.9e7345c1.png";